/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 */

import { basePath } from '../../constants/commonConstants';
import { makeRequest } from '../../helpers';

export const getTravelResources = async (props = {}) => {
  return await makeRequest({
    method: 'GET',
    url: `${basePath}/travel/quote_parameters`,
    history: props.history
  });
};
